<template>
    <div class="wrapper">
        <div class="content">
            <section class="accountCheck" v-if="!loggedIn">
                <header>
                    <h4>Czy posiadasz już konto w naszym serwisie?</h4>
                </header>
                <div class="flex-center">
                    <button class="default reverse" :class="{ active: haveAccount == 1 }" @click="changeHaveAccount(1)">Mam już konto</button>
                    <button class="default reverse" :class="{ active: haveAccount == 0 }" @click="changeHaveAccount(0), changeHaveCompany(1)">Nie mam jeszcze konta</button>
                </div>
            </section>
            <!-- <section class="businessCheck" v-if="haveAccount == 0 && !loggedIn">
                <header>
                    <h4>Czy posiadasz już działalność?</h4>
                </header>
                <div class="flex-center">
                    <button class="default reverse" :class="{ active: haveCompany == 1 }" @click="changeHaveCompany(1)">Mam już firmę</button>
                    <button class="default reverse" :class="{ active: haveCompany == 0 }" @click="changeHaveCompany(0)">Nie mam jeszcze firmy</button>
                </div>
            </section> -->
            <!-- <section class="withoutCompany" v-if="haveCompany == 0 && haveAccount == 0">
                <div class="error">
                    <h5>Prace w toku</h5>
                    <h6>Ta funkcjonalność nie jest jeszcze dostępna</h6>
                    <img src="../assets/workInProgress.png" alt="">
                </div>
            </section> -->
            <section class="loginForm" v-if="haveAccount == 1 && pickCompany != 1 && !loggedIn">
                <header>
                    <h4>Zaloguj się</h4>
                </header>
                <div class="data">
                    <div class="input-container">
                        <header>
                            <h6 v-if="email">Email</h6>
                        </header>
                        <div class="input-box">
                            <input type="email" class="data" @keyup.enter="validateLogin()" :class="{ error: validValues[0].value == 1  || validLogin.value == 1 }" placeholder="Adres e-mail" v-model="email" @blur="storeInLocalStorage(email, 'email', 'formData')" />
                            <i class="material-icons" v-if="validValues[0].value == 1">close</i>
                        </div>
                        <p v-if="validValues[0].value == 1">{{ validValues[0].text }}</p>
                    </div>
                    <div class="input-container">
                        <header>
                            <h6 v-if="password1">Hasło</h6>
                        </header>
                        <div class="input-box">
                            <input type="password" class="data" @keyup.enter="validateLogin()" :class="{ error: validValues[1].value == 1 || validLogin.value == 1 }" placeholder="Hasło" v-model="password1" />
                            <i class="material-icons" v-if="validValues[1].value == 1">close</i>
                        </div>
                        <p v-if="validValues[1].value == 1">{{ validValues[1].text }}</p>
                        <p v-if="validLogin.value == 1">{{ validLogin.text }}</p>
                    </div>
                    <button class="default small reverse" @click="validateLogin()">Zaloguj</button>
                </div>
            </section>
            <section class="pickCompanyForm" v-if="loggedIn">
                <header class="flex">
                    <h4>Konto - {{ this.email }}</h4>
                    <button class="default small reverse" @click="logout">Wyloguj</button>
                </header>
                <h6>Wybierz swoją działalność</h6>
                <ul class="companies">
                    <li v-for="(company, index) in companiesList" :key="'company' + index" @click="chooseCompany(company)" :class="{ bought: company.isServiceActive }">
                        {{ company.company_name }}
                        <i v-if="company.isServiceActive" class="material-icons">
                            check
                        </i>
                    </li>
                </ul>
                <button class="default small reverse" @click="changeAddCompany(1)">Dodaj nową</button>
            </section>
            <section class="nipAndBusinessTypeForm" v-if="(haveCompany == 1 && haveAccount == 0 && !loggedIn) || (addCompany == 1 && loggedIn)">
                <header class="no-flex">
                    <h4>Podaj NIP i wybierz typ działalności Twojej firmy.</h4>
                    <h5>Reszta danych zostanie automatycznie pobrana z bazy CEiDG i GUS.</h5>
                </header>
                <div class="data">
                    <div class="input-container" title="NIP">
                        <header>
                        <h6 v-if="nip">NIP</h6>
                        </header>
                        <div class="input-box">
                            <input class="data" @keyup.enter="checkNipAndDownloadData()" :class="{ error: validValues[2].value == 1 }" type="number" placeholder="NIP*" v-model="nip" @blur="storeInLocalStorage(nip, 'nip', 'formData')" maxlength="10">
                            <i class="material-icons" v-if="validValues[2].value == 1">close</i>
                        </div>
                        <p v-if="validValues[2].value == 1">{{ validValues[2].text  }}</p>
                    </div>
                    <button v-if="!loading" class="default small reverse" @click="checkNipAndDownloadData()">Pobierz dane</button>
                    <div class="loader" v-if="loading">
                        <div>
                            <Loader/>
                        </div>
                    </div>
                </div>
            </section>
            <section v-if="(haveCompany == 1 && haveAccount == 0 && !loggedIn && gusDataVisible) || (loggedIn && gusDataVisible)">
                <header>
                    <h4>Sprawdź dane</h4>
                    <div class="icon" title="Infomacje dotyczące danych" @click="showPopup(0)">
                        <i class="material-icons">info</i>
                    </div>
                </header>
                <div class="warning" v-if="businessType == 'SPÓŁKI CYWILNE PROWADZĄCE DZIAŁALNOŚĆ NA PODSTAWIE UMOWY ZAWARTEJ ZGODNIE Z KODEKSEM CYWILNYM'">
                    <h4>UWAGA!</h4>
                    <p>W przypadku spółki cywilnej wymagane jest wysłanie skanu umowy spółki na adres: <span>bok@afkcob.pl</span></p>
                </div>
                <div class="data">
                    <div class="input-container" title="KRS" v-if="krs">
                        <header>
                            <h6>KRS</h6>
                        </header>
                        <div class="input-box">
                            <input type="number" class="data" placeholder="KRS" v-model="krs" :disabled="true">
                        </div>
                    </div>
                    <div class="input-container" title="Regon"  v-if="regon">
                        <header>
                            <h6>Regon</h6>
                        </header>
                        <div class="input-box">
                            <input type="number" class="data" placeholder="Regon*" v-model="regon" :disabled="true">
                        </div>
                    </div>
                    <div class="input-container" title="Nazwa firmy" v-if="companyName">
                        <header>
                            <h6>Nazwa firmy</h6>
                        </header>
                        <div class="input-box">
                            <input class="data" type="text" placeholder="Nazwa firmy*" v-model="companyName" :disabled="true">
                        </div>
                    </div>
                    <div class="input-container" title="Typ działalności" v-if="businessType">
                        <header>
                            <h6>Typ działalności</h6>
                        </header>
                        <div class="input-box">
                            <input class="data" type="text" placeholder="Typ działalności*" v-model="businessType" :disabled="true">
                        </div>
                    </div>
                    <div class="input-container" title="Miejscowość" v-if="city">
                        <header>
                            <h6>Miejscowość</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" placeholder="Miejscowość*" v-model="city" :disabled="true">
                        </div>
                    </div>
                    <div class="input-container" title="Kod pocztowy" v-if="postCode">
                        <header>
                            <h6>Kod pocztowy</h6>
                        </header>
                        <div class="input-box" >
                            <input type="text" class="data" placeholder="Kod pocztowy*" v-model="postCode" :disabled="true">
                        </div>
                    </div>
                    <div class="input-container" title="Ulica" v-if="street">
                        <header>
                            <h6>Ulica</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" placeholder="Ulica*" v-model="street" :disabled="true">
                        </div>
                    </div>
                    <div class="input-container" title="Numer nieruchomości" v-if="houseNumber">
                        <header>
                            <h6>Numer domu</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" placeholder="Numer nieruchomości*" v-model="houseNumber" :disabled="true">
                        </div>
                    </div>
                    <div class="input-container" title="Numer lokalu" v-if="apartmentNumber">
                        <header>
                            <h6>Numer lokalu</h6>
                        </header>
                        <div class="input-box">
                            <input type="text" class="data" placeholder="Numer lokalu" v-model="apartmentNumber" :disabled="true">
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <order-nav forwardString="Kontynuuj" backPath="/zamowienie/krok/1" @goForward="goForward" :forwardPushingWay="forwardPushingWay"  :forwardDisabled="true"></order-nav>
    </div>
</template>

<script>
    import localStorageManager from '../functions/localStorageManager';
    import validation from '../functions/validation';
    import OrderNav from '@/components/OrderNav.vue';
    import Loader from '../components/Loader';
    
    export default {
        name: 'Step2LogAndNip',
        components: {
            OrderNav,
            Loader,
        },
        data() {
            return {
                forwardPushingWay: 1,
                loading: false,
                haveCompany: -1,
                haveAccount: -1,
                pickCompany: 0,
                addCompany: 0,
                gusDataVisible: 0,
                checkNip: 0,
                checkData: 0,
                krsState: 0,
                krsPlaceholder: '',
                email: '',
                password1: '',
                nip: '',
                businessType: '',
                validValues: new Array(4).fill(0).map(() => ({ value: 0, text: 'Podana wartość jest nieprawidłowa', })),
                validLogin: { value: 0, text: '' },
                companiesList: [],
                krs: '',
                regon: '',
                companyName: '',
                businessType: '',
                city: '',
                postCode: '',
                street: '',
                houseNumber: '',
                apartmentNumber: '',
                infoTexts: [
                    'Sprawdź poprawność danych. Informacje pobierane są automatycznie z bazy danych GUS.',
                ],
            }
        },
        methods: {
            goForward() {
                this.$emit('goForward');
            },
            changeAddCompany(id) {

                    this.$store.commit('changeOrderNavDisable', true);
                    this.clearGusData();
                    this.gusDataVisible = 0;

                this.addCompany = id;

            },
            changeHaveCompany(id){
                this.haveCompany = id;
            },
            changeHaveAccount(id){
                if(id != this.haveAccount) {
                    this.$store.commit('changeOrderNavDisable', true);
                    this.clearGusData();
                    this.gusDataVisible = 0;
                }
                this.haveAccount = id;
            },
            changeCheckData(id){
                this.checkData = id;
            },
            async chooseCompany(company) {
                this.addCompany = 0;
                localStorageManager.storeInLocalStorage(this.addCompany, 'addCompany', 'step2State');
                const payload = { nip: company.nip, serviceType: this.serviceType }
                await this.axios
                .get(this.api + 'company/gus', { params: payload })
                .then(async response => {
                    if(response) {
                        if(response.data.status == 1) {
                            this.storeGusDataInLocalStorage(response.data.data);
                            this.gusDataVisible = 1;
                            this.$store.commit('changeOrderNavDisable', false);
                            if(this.checkNip == 1) {
                                let formData = JSON.parse(localStorage.getItem('formData'));
                                if(formData.contractSigners) {
                                    delete formData.contractSigners;
                                    delete formData.validContractSignersValues;
                                }
                                if(formData.correspondenceAddress) {
                                    delete formData.correspondenceAddress;
                                }
                                if(formData.correspondenceEmail) {
                                    delete formData.correspondenceEmail;
                                    delete formData.validCorrespondenceEmailValues;
                                }
                                if(formData.correspondenceNumber) {
                                    delete formData.correspondenceNumber;
                                    delete formData.validCorrespondenceNumberValues;
                                }
                                if(formData.correspondencePeople) {
                                    delete formData.correspondencePeople;
                                    delete formData.validCorrespondencePeopleValues;
                                }
                                localStorage.setItem('formData', JSON.stringify(formData));
                            }
                        } else {
                            this.toggleAlert(0, response.data.msg);
                        }
                    }
                });
            },
            async checkNipAndDownloadData() {
                this.loading = true;
                await this.downloadData().then(r => {
                    this.loading = false;
                    if(this.checkNip == 1) {
                        this.gusDataVisible = 1;
                        this.$store.commit('changeOrderNavDisable', false);
                    } else {
                        this.$store.commit('changeOrderNavDisable', true);
                    }
                });
            },
            clearGusData() {
                if(localStorage.formData) {
                    let formData = JSON.parse(localStorage.getItem('formData'));
                    delete formData.krs;
                    delete formData.regon;
                    delete formData.companyName;
                    delete formData.businessType;
                    delete formData.city;
                    delete formData.postCode;
                    delete formData.street;
                    delete formData.houseNumber;
                    delete formData.apartmentNumber;
                    localStorage.setItem('formData', JSON.stringify(formData));
                }
                this.krs = '';
                this.regon = '';
                this.companyName = '';
                this.businessType = '';
                this.city = '';
                this.postCode = '';
                this.street = '';
                this.houseNumber = '';
                this.apartmentNumber = '';
            },
            async downloadData(){
                this.validValues[2] = validation.validateNip(this.nip, this.validValues[2]);
                if(this.validValues[2].value == 0){
                    let self = this;
                    await this.axios
                    .get(this.api + 'company/data', { params: { nip: this.nip } })
                    .then(response => {
                        if(response.data.status == 0) {
                            if(response.data.taken) {
                                if(this.haveAccount != 1) {
                                    this.validValues[2].value = 1;
                                    this.validValues[2].text = 'Podany NIP jest już w bazie, zaloguj się żeby zarządzać usługami firmy';
                                    this.checkNip = 0;
                                } else {
                                    this.validValues[2].value = 1;
                                    this.validValues[2].text = 'Podany NIP jest już w bazie';
                                    this.checkNip = 0;
                                }
                            } else {
                                this.validValues[2].value = 1;
                                this.validValues[2].text = response.data.msg;
                            }
                        }else{
                            if(response.data.data.ErrorCode) {
                                this.validValues[2].value = 1;
                                this.validValues[2].text = response.data.data.ErrorMessagePl;
                                this.checkNip = 0;
                            } else {
                                this.storeGusDataInLocalStorage(response.data.data);
                            }
                        }
                    })
                    .catch( error => {
                        this.checkNip = 0;
                    })
                }
            },
            storeGusDataInLocalStorage(data) {
                let store = {};
                if(localStorage.formData !== undefined) {
                    store = JSON.parse(localStorage.getItem('formData'));
                } 
                if(data.Nip) {
                    store.nip = data.Nip;
                }
                if(data.Krs) {
                    store.krs = data.Krs;
                    this.krs = data.Krs;
                } else {
                    store.krs = '';
                    this.krs = '';
                }
                if(data.Regon) {
                    store.regon = data.Regon;
                    this.regon = data.Regon;
                }
                if(data.Nazwa) {
                    store.companyName = data.Nazwa;
                    this.companyName = data.Nazwa;
                }
                if(data.TypD) {
                    store.businessType = data.TypD;
                    this.businessType = data.TypD;
                }
                if(data.Miejscowosc) {
                    store.city = data.Miejscowosc;
                    this.city = data.Miejscowosc;
                }
                if(data.KodPocztowy) {
                    store.postCode = data.KodPocztowy;
                    this.postCode = data.KodPocztowy;
                }
                if(data.Ulica) {
                    store.street = data.Ulica;
                    this.street = data.Ulica;
                }
                if(data.NrNieruchomosci) {
                    store.houseNumber = data.NrNieruchomosci;
                    this.houseNumber = data.NrNieruchomosci;
                }
                if(data.NrLokalu) {
                    store.apartmentNumber = data.NrLokalu;
                    this.apartmentNumber = data.NrLokalu;
                }
                localStorage.setItem('formData', JSON.stringify(store));
                this.checkNip = 1;
            },
            async getCompaniesList() {
                return await this.axios
                .get(this.api + 'company/list', { params: { serviceType: this.serviceType } })
                .then(response => {
                    if(response.data.status == 1) {
                        return response.data.companiesList;
                    }
                });
            },
            setKRS() {
                if(this.validValues[3].value == 1) {
                    this.checkBusinessType = 0;
                } else {
                    if(this.businessType.localeCompare('Jednoosobowa działalność gospodarcza') === 0 || this.businessType.localeCompare('Spółka cywilna') === 0) {
                    this.krsState = 0;
                    this.storeInLocalStorage(this.krsState, 'krsState', 'step2State');
                    } else if (this.businessType.localeCompare('Stowarzyszenie') === 0 || this.businessType.localeCompare('Fundacja') === 0) {
                    this.krsState = 1;
                    this.krsPlaceholder = 'KRS';
                    this.storeInLocalStorage(this.krsState, 'krsState', 'step2State');
                    this.storeInLocalStorage(this.krsPlaceholder, 'krsPlaceholder', 'step2State');
                    } else {
                    this.krsState = 2;
                    this.krsPlaceholder = 'KRS*';
                    this.storeInLocalStorage(this.krsState, 'krsState', 'step2State');
                    this.storeInLocalStorage(this.krsPlaceholder, 'krsPlaceholder', 'step2State');
                    }
                    this.checkBusinessType = 1;
                }
            },
            storeInLocalStorage(value, valueName, objectName) {
                localStorageManager.storeInLocalStorage(value, valueName, objectName);
            },
            async validateLogin() {
                this.validValues[0] = validation.validateEmail(this.email, this.validValues[0]);
                this.validValues[1] = validation.validateIsNotEmpty(this.password1, this.validValues[1]);
                if(this.validValues[0].value != 1 && this.validValues[1].value != 1) {
                    await this.login()
                    .then(async response => {
                        if(response == 1) {
                            this.companiesList = await this.getCompaniesList();
                            this.pickCompany = 1;
                            this.$store.commit('changeLoggedIn', 1);
                        } else if(response == 2) {
                            this.$store.commit('changeActivationCodeVerification', false);
                            this.$store.commit('togglePopupCode', 1);
                        }
                    });
                }
            },
            login() {
                return new Promise(async (resolve, reject) => {
                    await this.axios
                    .get(this.api + 'auth/login', { params: { email: this.email, password: this.password1 } })
                    .then(response => {
                        if(response) {
                        if(response.data.status == 1) {
                            localStorage.setItem('accessToken', response.data.accessToken);
                            localStorage.setItem('refreshToken', response.data.refreshToken);
                            this.$store.commit('changeLoggedIn', 1);
                            this.validLogin.value = 0;
                            resolve(1);
                        } else if(response.data.status == 2) {
                            localStorage.setItem('accessToken', response.data.accessToken);
                            localStorage.setItem('refreshToken', response.data.refreshToken);
                            this.$store.commit('changeLoggedIn', 1);
                            this.validLogin.value = 0;
                            resolve(2);
                        } else {
                            this.validLogin.value = 1;
                            this.validLogin.text = response.data.msg;
                            resolve(0);
                        }
                        } else {
                            console.log("ERR");
                            resolve(0);
                        }
                    });
                });
            },
            async logout() {
                await this.axios
                .put(this.api + 'auth/logout')
                .then(response => {
                    if(response.data.status == 1) {
                        this.$store.commit('changeLoggedIn', 0);
                        localStorage.setItem('formStep', 2);
                        this.pickCompany = 0;
                        this.addCompany = 0;
                        this.email = '';
                        this.password1 = '';
                        this.nip = '';
                        localStorage.removeItem('accessToken');
                        localStorage.removeItem('refreshToken');
                        localStorage.removeItem('formData');
                    } else {
                        this.toggleAlert(0, 'Coś poszło nie tak');
                    }
                });
            },
            toggleAlert(type, msg) {
                this.$store.commit('toggleAlert', {
                    visibility: 1,
                    type: type,
                    msg: msg
                });
            },
            showPopup(id) {
                this.$emit('showPopup', this.infoTexts[id]);
            },
        },
        computed: {
            api(){
                return this.$store.state.api;
            },
            isActivationCodeVerified() {
                return this.$store.state.isActivationCodeVerified;
            },
            loggedIn() {
                return this.$store.state.loggedIn;
            },
            serviceType() {
                return this.$store.state.serviceType;
            },
        },
        watch: {
            async isActivationCodeVerified() {
                if(this.isActivationCodeVerified) {
                    this.companiesList = await this.getCompaniesList();
                    this.pickCompany = 1;
                    this.$store.commit('changeLoggedIn', 1);
                }
            },
            haveCompany() {
                localStorageManager.storeInLocalStorage(this.haveCompany, 'haveCompany', 'step2State');
            },
            haveAccount() {
                localStorageManager.storeInLocalStorage(this.haveAccount, 'haveAccount', 'step2State');
            },
            pickCompany() {
                localStorageManager.storeInLocalStorage(this.pickCompany, 'pickCompany', 'step2State');
            },
            addCompany() {
                localStorageManager.storeInLocalStorage(this.addCompany, 'addCompany', 'step2State');
            },
            checkBusinessType() {
                localStorageManager.storeInLocalStorage(this.checkBusinessType, 'checkBusinessType', 'step2State');
            },
        },
        async mounted() {
            this.$store.commit('changeOrderNavDisable', true);
            if(localStorage.formData !== undefined) {
                const formData = JSON.parse(localStorage.formData);
                Object.keys(formData).forEach(key => {
                    if(this[key] == '' || this[key]) {
                        this[key] = formData[key];
                    }
                });
            }
            if(localStorage.step2State !== undefined) {
                const step2State = JSON.parse(localStorage.step2State);
                Object.keys(step2State).forEach(key => {
                    if(this[key] == '' || this[key]) {
                        this[key] = step2State[key];
                    }
                });
            }
            if(localStorage.accessToken && localStorage.refreshToken) {
                this.companiesList = await this.getCompaniesList();
            } else {
                this.pickCompany = 0;
                localStorageManager.storeInLocalStorage(this.pickCompany, 'pickCompany', 'step2State');
                this.addCompany = 0;
                localStorageManager.storeInLocalStorage(this.addCompany, 'addCompany', 'step2State');
            }
            // let form = JSON.parse(localStorage.formData);
            // delete form['contractSigners'];
            // delete form['correspondenceAddress'];
            // delete form['correspondenceEmail'];
            // delete form['correspondenceNumber'];
            // delete form['correspondencePeople'];
            // delete form['validContractSignersValues'];
            // delete form['validCorrespondenceEmailValues'];
            // delete form['validCorrespondenceNumberValues'];
            // delete form['validCorrespondencePeopleValues'];
            // localStorage.setItem('formData', JSON.stringify(form));
        },
    }   
</script>

<style lang="scss" scoped>
    // @import '../styles/step2Styles.scss';
    button.default { margin-bottom: 30px; }
    div.error { width: 50%; margin: auto; }
    div.error img { width: 100%; }
    div.error h5 { margin: 0; padding: 0; font-size: 40px; font-weight: 500; color: $fontBlack; text-align: center; }
    div.error h6 { margin: 0; padding: 0; font-size: 20px; font-weight: 400; color: $fontGray; text-align: center; }
    div.warning {
        background-color: $red;
        margin: 10px auto;
        padding: 10px;
        border-radius: 4px;
        width: 450px;
    }
    div.warning h4 {
        margin: 0;
        padding: 0;
        font-weight: 500;
        font-size: 14px;
        color: #fff;
    }
    div.warning p {
        margin: 0;
        padding: 0;
        font-size: 13px;
        color: rgba(255, 255, 255, 0.9);
    }
    div.warning p span {
        font-weight: 700;
        font-size: 14px;
        color: #fff;
    }
</style>
